import { createContext, useContext } from "react";
export const SidebarContext = createContext({
    isOpen: false,
    toggleMobile: () => void 0,
    toggleDesktop: () => void 0,
});
export function useSidebarToggle() {
    return useContext(SidebarContext);
}
//# sourceMappingURL=SidebarContext.js.map